export default __webpack_public_path__ + "static/media/youth_empower.9b6037d0.jpg";